import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    Renderer2,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'fi-brand-color-picker',
    templateUrl: './fi-brand-color-picker.component.html',
    styleUrls: ['./fi-brand-color-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-brand-color-picker' },
    standalone: false,
})
export class FiBrandColorPickerComponent implements OnInit {
    @Input() color: string;
    @Output() colorChange = new EventEmitter<string>();
    @Input() label: string;

    @ViewChild('colorPreviewCard') colorPreviewCard: ElementRef;

    constructor(private renderer: Renderer2) {}

    ngOnInit(): void {
        setTimeout(() => this.setColorPreviewCardBackground());
    }

    private setColorPreviewCardBackground() {
        this.renderer.setStyle(this.colorPreviewCard.nativeElement, 'backgroundColor', `#${this.color}`);
    }

    onColorPickerChange(newHexColor: string) {
        this.color = newHexColor.slice(1);
        this.setColorPreviewCardBackground();
        this.colorChange.emit(this.color);
    }
}
